/* MANA i18n — swaps text EN<->NL using window.MANA_NL dictionary.
   Handles plain text nodes AND elements char-split by the text animation. */
(function(){
  function norm(t){ return t.replace(/[\s\u00A0]+/g,' ').trim(); }
  var nodes = null, attrs = null, els = null;
  function collect(){
    var D = window.MANA_NL || {};
    nodes = []; attrs = []; els = [];
    var matchedParents = new Set();
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function(n){
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === 'SCRIPT' || p === 'STYLE' || p === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return /\S/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var n;
    while ((n = w.nextNode())) {
      var key = norm(n.nodeValue);
      if (D[key] !== undefined) {
        nodes.push({ node: n, en: n.nodeValue, nl: D[key] });
        var a = n.parentNode;
        while (a && a !== document.body) { matchedParents.add(a); a = a.parentNode; }
      }
    }
    // element-level pass: whole-element textContent matches (char-split animations, <br> splits)
    var cand = [];
    document.body.querySelectorAll('h1,h2,h3,h4,h5,a,button,div,span,p,li,blockquote').forEach(function(el){
      if (el.querySelector('script,style,img,input,select,textarea,iframe,video')) return;
      var key = norm(el.textContent || '');
      if (!key || D[key] === undefined) return;
      // skip if an inner text node already carries this exact translation
      var covered = nodes.some(function(e){ return el.contains(e.node) && e.nl === D[key]; });
      if (covered) return;
      cand.push({ el: el, en: el.innerHTML, nl: D[key] });
    });
    // outermost wins only when it translates something MORE than the inner candidate
    // (whole-phrase "Explore Memberships" beats inner "Memberships"); among candidates
    // with the same translation keep the DEEPEST element (the real h1/h2, not its wrapper div)
    cand.forEach(function(c){
      var dropped = cand.some(function(o){
        if (o === c) return false;
        if (o.el.contains(c.el)) return o.nl !== c.nl;      // real outer phrase wins
        if (c.el.contains(o.el)) return o.nl === c.nl;      // same key: deeper one wins
        return false;
      });
      if (!dropped) els.push(c);
    });
    // whole-phrase element matches win over word-level text nodes inside them
    nodes = nodes.filter(function(e){
      return !els.some(function(c){ return c.el.contains(e.node); });
    });
    document.querySelectorAll('[placeholder]').forEach(function(el){
      var v = el.getAttribute('placeholder'), k = norm(v || '');
      if (D[k] !== undefined) attrs.push({ el: el, attr: 'placeholder', en: v, nl: D[k] });
    });
    document.querySelectorAll('input[type="submit"]').forEach(function(el){
      var v = el.getAttribute('value'), k = norm(v || '');
      if (D[k] !== undefined) attrs.push({ el: el, attr: 'value', en: v, nl: D[k] });
    });
  }
  window.manaApplyLang = function(lang){
    if (!nodes) collect();
    var nl = (lang === 'nl');
    nodes.forEach(function(e){ e.node.nodeValue = nl ? e.nl : e.en; });
    els.forEach(function(e){ if (nl) { e.el.textContent = e.nl; } else { e.el.innerHTML = e.en; } });
    attrs.forEach(function(e){ e.el.setAttribute(e.attr, nl ? e.nl : e.en); });
    document.documentElement.lang = nl ? 'nl' : 'en';
    document.dispatchEvent(new CustomEvent('mana-lang-applied', { detail: { lang: lang } }));
  };
  function init(){
    // Mobile: language toggle lives in the hamburger menu (nav-right one is hidden by CSS)
    var mobWrap = document.querySelector('.wrap-mobile-menu .mobile-nav-top-tile');
    if (mobWrap && !document.querySelector('.mana-lang-mobile')) {
      var d = document.createElement('div');
      d.innerHTML = '<div class="divider-dark-16"></div><div class="nav-column-item"><div class="mana-lang mana-lang-mobile" role="group" aria-label="Language"><button type="button" class="mana-lang-btn" data-lang="nl">NL</button><button type="button" class="mana-lang-btn" data-lang="en">ENG</button></div></div>';
      while (d.firstChild) mobWrap.appendChild(d.firstChild);
    }
    var saved = localStorage.getItem('mana-lang') || 'en';
    document.querySelectorAll('.mana-lang-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-lang') === saved);
      b.addEventListener('click', function(){
        localStorage.setItem('mana-lang', b.getAttribute('data-lang'));
        document.querySelectorAll('.mana-lang-btn').forEach(function(x){ x.classList.toggle('active', x.getAttribute('data-lang') === b.getAttribute('data-lang')); });
        window.manaApplyLang(b.getAttribute('data-lang'));
      });
    });
    // collect after the text-split animation has initialized
    if ((localStorage.getItem('mana-lang') || 'en') === 'nl') {
      setTimeout(function(){ window.manaApplyLang('nl'); }, 150);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
